<template>
  <v-flex>
    <v-alert :value="triggerAlert"
             color="accent"
             icon="priority_high"
             outline
             dismissible>
      {{errorMessage}}
    </v-alert>
    <v-select
      v-if="inputData.type === 'select'"
      :items="getOptions"
      :rules="rules"
      v-model="value"
      @change="emitData"
      :required="!!inputData.is_required"
      box
      :label="getLabel"
    ></v-select>

    <v-select v-if="inputData.type === 'multiselect'"
              :items="getOptions"
              multiple
              chips
              :rules="rules"
              v-model="multiselect"
              box
              @change="emitData"
              :label="getLabel"
    ></v-select>


    <div v-if="inputData.type === 'html'"
         v-html="inputData.html_content"
    ></div>

    <v-text-field
      v-if="inputData.type === 'multiselect'"
      label="Andere..."
      single-line
      v-model="customOption"
      filled
    ></v-text-field>

    <v-btn :disabled="customOption===''" v-if="inputData.type === 'multiselect'" @click="addOption"
           class="ml-0 mb-4" color="accent">
      Option Hinzufügen
    </v-btn>

    <v-checkbox
      v-if="inputData.type === 'checkbox'"
      v-model="value"
      :rules="rules"
      @change="emitData">
      <template v-slot:label>
        {{getLabel}}
      </template>
    </v-checkbox>

    <v-text-field
      v-if="inputData.type === 'textbox'"
      v-model="value"
      :rules="rules"
      :label="getLabel"
      @input="emitData"
      m-0
    ></v-text-field>

    <v-autocomplete
      v-if="inputData.type === 'cities'"
      v-model="value"
      :items="getOptions"
      :rules="rules"
      @change="emitData"
      dense
      filled
      :label="getLabel"
    >
    </v-autocomplete>

    <v-form v-if="inputData.type === 'fileupload'">

      <h4 class="lighten-4 mb-2">{{getLabel}} </h4>
      <v-btn class="ml-0 mb-4" color="accent"
             @click="$refs.inputUpload.click()">Datei Auswählen
      </v-btn>
      <input v-show="false" ref="inputUpload" type="file"
             @change="handleFileInput">
      <v-btn class="ml-0 mb-4" :disabled="!fileReady" @click="submitFiles">Datei hochladen
      </v-btn>
      <p v-if="uploadSuccessful" class="success--text">Datei(en) wurden erfolgreich hochgeladen</p>
      <v-item-group v-if="fileReady" multiple>
        <v-item
          v-for="file in files"
          :key="file.name"
        >
          <v-chip
            slot-scope="{ active }"
            :selected="active"
            @input="deleteFiles"
            close
          >
            {{ file.name }}
          </v-chip>
        </v-item>
      </v-item-group>
    </v-form>
  </v-flex>

</template>

<script>
  import axios from 'axios'

  export default {
    name: 'InputComponent',
    props: {
      inputData: {
        type: Object,
        required: true
      },
      selectedInputs: {
        type: Array,
        required: false
      },
      slug: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        formData: {},
        uploadSuccessful: false,
        errorMessage: 'Es gab einen Fehler',
        triggerAlert: false,
        customOption: '',
        duplicateFileName: false,
        files: [],
        fileReady: false,
        validation: {
          'name': v => !!v || 'Feld muss ein Name sein',
          'required': v => !!v || 'Dieses Feld muss ausgefüllt sein',
          'number': v => {
            if (!v.trim()) return true
            if (!isNaN(parseFloat(v))) return true
            return 'Feld muss eine Nummer sein'
          },
          'email': v => /.+@.+/.test(v) || 'Feld muss eine Email sein'
        }
      }
    },
    methods: {
      emitData: function () {
        this.$emit('emit-data', this.formData)
      },
      addOption: function () {
        if (this.customOption !== '') {
          const customOptionArray = []
          customOptionArray['id'] = null
          customOptionArray['value'] = this.customOption
          customOptionArray['text'] = this.customOption
          this.inputData.options.push(customOptionArray)
          this.customOption = ''
        }
      },
      deleteFiles: function () {
        this.fileReady = false
        this.files = []
      },
      handleFileInput: function (event) {
        this.fileReady = true
        this.uploadSuccessful = false
        if (Array.isArray(this.files) && !this.files.length) {
          this.files = event.target.files
          return
        }
        for (let file of this.files) {
          if (file.name === event.target.files.name) {
            this.duplicateFileName = true
          }
        }
        if (!this.duplicateFileName) {
          this.files = [...this.files, ...event.target.files]
          return
        }
        this.duplicateFileName = false
      },
      submitFiles: function () {
        const URL = '/api/v1/wizard/' + this.slug + '/upload-file'
        const FORM_DATA = new FormData()
        const HEADERS = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        for (let i = 0; i < this.files.length; i++) {
          FORM_DATA.append('files[' + i + '][value]', this.files[i])
        }
        axios.post(URL, FORM_DATA, HEADERS)
          .then(resp => {
            if (Array.isArray(this.formData[this.inputData.name])) {
              this.formData[this.inputData.name].push({ 'value': resp.data })
            } else {
              this.formData[this.inputData.name] = [{ 'value': resp.data }]
            }
            this.fileReady = false
            this.files = []
            this.duplicateFileName = false
            this.uploadSuccessful = true
            this.emitData()
          })
          .catch(e => {
            this.errorMessage = e.toString()
            this.triggerAlert = true
          })
      }
    },
    mounted() {
      if (this.inputData.type === 'cities') {
        axios
          .get('/api/v1/staedteliste')
          .then(resp => {
            this.inputData.options = resp.data
            console.log(resp.data)
          })
          .catch(e => {
            this.errorMessage = e.toString()
            this.triggerAlert = true
          })
      }
    },
    computed: {
      getLabel: function () {
        if (this.inputData.hasOwnProperty('label')) {

          return this.inputData.label
        }

        return 'Keine Beschriftung'
      },
      rules: function () {
        const rules = []

        if (this.inputData.is_required) {
          rules.push(this.validation['required'])
        }
        if (this.inputData.hasOwnProperty('expected_input')) {
          const expectedInput = this.inputData['expected_input']
          if (this.validation.hasOwnProperty(expectedInput)) {
            rules.push(this.validation[expectedInput])
          }
        }
        return rules
      },
      getItems: function () {
        return this.inputData.options.map(
          item => item.text
        )
      },
      getOptions: function () {

        if (this.inputData.type === 'cities') {
          const cities = []
          this.inputData.options.forEach(item => {
            cities.push(item.name)
          })

          return cities
        }

        return this.inputData.options.filter(
          item => !('target_id' in item) || ('target_id' in item && this.selectedInputs.includes(item['target_id']))
        )
      },
      value: {
        get() {
          if (this.formData.hasOwnProperty(this.inputData.name) && this.formData[this.inputData.name].hasOwnProperty('value')) {
            return this.formData[this.inputData.name].value
          }
          return ''
        },
        set(val) {
          let id = -1
          this.inputData.options.forEach(option => {
            if (option.value === val) {
              id = option.id
            }
          })
          this.formData[this.inputData.name] = {
            value: val
          }
          if (id > 0) {
            this.formData[this.inputData.name] = { ...this.formData[this.inputData.name], ...{ id: id } }
          }
        }
      },
      multiselect: {
        get() {
          const multiselect = []
          if (this.formData.hasOwnProperty(this.inputData.name)) {
            this.formData[this.inputData.name].forEach(item => {
              if (item.hasOwnProperty('value'))
                multiselect.push(item.value)
            })

            return multiselect
          }

          return ''
        },
        set(val) {
          let id = -1
          const multiselect = []
          if (Array.isArray(val)) {
            val.forEach(item => {
              this.inputData.options.forEach(option => {
                if (option.value === item) {
                  id = option.id
                }
              })
              multiselect.push({ id: id, value: item })
              return item
            })
            this.formData[this.inputData.name] = multiselect
          }
        }
      }
    }
  }
</script>
